import DinPage from './DinPage';
export default DinPage;
